/**
 * 用户类型
 */
export const PERSONAL_TYPE = 1
export const COMPANY_TYPE = 0
